import React, { useEffect, useRef } from 'react';
import { connect } from "react-redux";
import * as Tools from "../../helpers/Tools";
import * as msgs from "../../constants/textConstants";
import * as d from "../../reducers/domainReducer";
import { logUI } from "../../api/andyliticsApi";
import { getFirstName } from "../../helpers/formatting";
import { withTranslation } from 'react-i18next';
import sunnydayWeb from '../../lotties/sunnyday_web.json';
import bluemoonWeb from '../../lotties/bluemoon_web.json';
import { HeroAnimation } from '../dashboard/HeroAnimation'
import { Typography } from '../../components/ecosystem';
import MyChartProxySelector from '../common/Proxy/MyChartProxySelector';

const HeroBanner = ({ primaryUser, isProxyUser, dateTimeOffset, insuranceLogo, insuranceLogoAltText, insuranceLogoClass, t, screenBreakPoint, isOpenHeroSectionToolTip, updateonBoardingToolTipState }) => {
    let animSrc = '';
    let displayName = '';
    let timeOfDay = "";

    const thisStartDate = new Date();
    const thisUTCDate = new Date(Date.parse(thisStartDate.toUTCString()) - (dateTimeOffset * 60000));
    const hour = thisUTCDate.getUTCHours();
    const lottiePlayer = useRef(null);

    useEffect(() => {
        logUI("MBHWeb.UI.HeroBanner.Loaded", new Date(), Tools.getURLPath());
    }, []);

    if (primaryUser && !isProxyUser) {
        displayName = getFirstName(primaryUser.displayName);
    } else if (isProxyUser) {
        displayName = "Family";
    }

    if (hour < 12) {
        animSrc = sunnydayWeb;
        timeOfDay = "morning";
    }
    else if (hour < 18) {
        animSrc = sunnydayWeb;
        timeOfDay = "afternoon";
    }
    else {
        animSrc = bluemoonWeb;
        timeOfDay = "evening";
    }

    const centerLogo = { alt: insuranceLogoAltText, src: insuranceLogo, class: insuranceLogoClass };
    const isMobile = !(screenBreakPoint === msgs.XL_DESKTOP || screenBreakPoint === msgs.XXL_DESKTOP) ? true : false;
    const isTablet = ([msgs.MD_TABLET, msgs.LG_TABLET]).indexOf(screenBreakPoint) > -1 ? true : false;
    const isXLDesktop = ([msgs.XL_DESKTOP]).indexOf(screenBreakPoint) > -1 ? true : false;

    return (
        <div className="row hero-banner">
            <div className="col-12 maxWidth-content">
                <div className="row hero-greeting-center-container">
                    <div className="col-6 col-lg-7 hero-greeting-center__content">
                        <div className="hero-greeting-center__content-main">
                            <div className="hero-greeting-center__heading">
                                <Typography
                                    type={isMobile ? "body-01" : isTablet ? "heading-05" : isXLDesktop ? "heading-06" : "display-01"}
                                    tag={"div"}
                                >
                                    {`Good ${timeOfDay}, `}
                                </Typography>
                                <Typography
                                    type={(isMobile || isTablet || isXLDesktop) ? "heading-06" : "display-01"}
                                    tag={"div"}
                                >
                                    {`${displayName.length > 0 ? displayName : ''}`}
                                </Typography>
                            </div>
                            <div className="hero-greeting-center__subtext">
                                <Typography type="body-03">
                                    {"Welcome to your health hub"}
                                </Typography>
                            </div>
                            {!isProxyUser && centerLogo &&
                                <div className={"hero-greeting-center__logo " + centerLogo.class}>
                                    <img className={"logo_frame"} alt={centerLogo.alt} src={centerLogo.src} />
                                </div>
                                }
                        </div>
                        <MyChartProxySelector
                            isMobile={isMobile}
                            isOpenHeroSectionToolTip={isOpenHeroSectionToolTip}
                            updateonBoardingToolTipState={updateonBoardingToolTipState}
                        />
                    </div>
                    <div className="col-6 col-lg-5 hero-greeting-center__animation">
                        <HeroAnimation
                            lottiePlayer={lottiePlayer}
                            src={animSrc}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        dateTimeOffset: state.domain.dto,
        primaryUser: d.hydrateProxyUser(state.domain.pu),
        hasMyChartLogin: state.domain.hm,
        isProxyUser: state.domain.ip,
        currentHealthPlanInfo: state.session.currentHealthPlanInfo,
        insuranceLogo: state.memberships.membershipBranding.insuranceLogo,
        insuranceLogoAltText: state.memberships.membershipBranding.insuranceLogoAltText,
        insuranceLogoClass: state.memberships.membershipBranding.insuranceLogoClass
    };
};

export default connect(mapStateToProps, null)(withTranslation()(HeroBanner));